import React from 'react';
import PageTitle from '../../Components/PageTitle';
import  code from '../../assets/images/code.png';
import { Link } from 'react-router-dom';
import { routes } from '../../routes';



function Hiring() {
	return (
		<>
			<PageTitle title="Hire Resources" />
			    <section className="second-level-section">
                    <div className="container">
                        <div className="row">
                            <div className='col-xxl-6 col-xl-6 col-lg-6 col-md-12 col-sm-12 col-12'>
                                <div className="left-box tick-icon-list">
                                    <h1>Hire <span>Software Developers</span> In India</h1>
                                    <h2>Lorem ipsum dolor sit amet (Pre-Vetted Experts)</h2>
                                        <p>Lorem ipsum dolor sit amet <strong> Aliquid reprehenderit repudiandae obcaecati !</strong> nobis quibusdam eaque sit mollitia dicta. Aliquid cumque non!<strong>Lorem ipsum dolor sit amet consectetur adipisicing elit. Veniam</strong> </p>
                                    <div className="bannertext">
                                        <p>Lorem ipsum dolor sit amet <strong> Aliquid reprehenderit repudiandae obcaecati !</strong> nobis quibusdam eaque sit mollitia dicta. Aliquid cumque non!<strong>Lorem ipsum dolor sit amet consectetur adipisicing elit. Veniam</strong> </p>
                                    </div>
                                    <div className="terms">
                                        <ul>
                                            <li>Language/time zone compatible staff</li>
                                            <li>On-time delivery</li>
                                            <li>No legal employment liability, no recruitment expenses</li>
                                            <li>Complete control over the team</li>
                                            <li>Transparency</li>
                                        </ul>
                                    </div>
                                    <div className="count-box-outer">
                                        <div className="count-box flex-4">
                                            <span className="count-box-big clr-yellow">17+</span>
                                            <span className="count-box-small">Years in Business</span>
                                        </div>
                                        <div className="count-box flex-4">
                                            <span className="count-box-big clr-yellow">650+</span>
                                            <span className="count-box-small">Software Developers</span>
                                        </div>
                                        <div className="count-box flex-4">
                                            <span className="count-box-big clr-yellow">2000+</span>
                                            <span className="count-box-small">Man Years Experience</span>
                                        </div>
                                        <div className="count-box flex-4">
                                            <span className="count-box-big clr-yellow">2500+</span>
                                            <span className="count-box-small">Satisfied Customers</span>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div className='col-xxl-6 col-xl-6 col-lg-6 col-md-12 col-sm-12 col-12'>
                                <div className='intersted'>
                                    <div className='inner_area'>
                                        <div className='code_img'>
                                            <div className='img_area'>
                                                <img src={code}  />
                                            </div>
                                            <div className='text_line'>
                                                Interested? Hire best Software developers now!
                                            </div>
                                            <div className='reach'>
                                                <Link to={routes.contact} className="btn-primary_set">Contact Us </Link>
                                            </div>   
                                        </div>
                                    </div>
                                </div>
                            </div> 
                        </div>
                    </div>
                </section>
		</>
	);
}

export default Hiring;
